export const getParsersDomains = (state) => state.parsers.parsersDomains;
export const getS3Domain = (state) => state.parsers.s3Domain;
